import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
// import { useAuth } from "../hooks/chat/useAuth";
import { LoadingScreen } from './LoadingScreen';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { state: { user, loading } } = useAuth();

  if (loading) {
    return <LoadingScreen />;
  }

  if (!user?.connected) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};